import React from "react";
import {
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import "../Commons/TableTag.css";
import IconEllipsis from "../Icon/Ellipsis.jsx";
class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // render each row details
  createRow = (row) => {
    let keys = Object.keys(row);

    return keys.map((key) => {
      return <td key={key}>{row[String(key)]}</td>;
    });
  };

  formatTime(dateString) {
    var date = new Date(dateString);
    return date.toLocaleDateString();
  }

  render() {
    const heads = this.props.heads;
    const selects = this.props.selects;
    const cols = heads.map((head) => (
      <th scope="col" key={head}>
        {head}
      </th>
    ));

    const rows = this.props.rows;
    const data = rows.map((row) => (
      <tr key={row.id}>
        <td style={{ paddingLeft: "50px" }}>
          <CustomInput
            type="checkbox"
            id={`select-${row.id}`}
            name={`select-${row.id}`}
            label=""
            checked={selects[row.post_category_join_id] || false}
            disabled={row["post"]["status"] !== "published"}
            onChange={(e) =>
              this.props.toggleSingle(
                e.target.checked,
                row.post_category_join_id
              )
            }
          />
        </td>
        <td key={`user-${row.id}-status`}>
          {row["post"]["status"] === "draft" ? (
            <p className="tag draft-tag">草稿</p>
          ) : (
            <p className="tag published-tag">正式發布</p>
          )}
        </td>
        <td key={`user-${row.id}-author`}>{`${row["post"]["author"]}`}</td>
        <td key={`user-${row.id}-title`}>{`${row["post"]["title"]}`}</td>
        <td
          key={`user-${row.id}-display_name`}
        >{`${row["category"]["display_name"]}`}</td>
        <td key={`user-${row.id}-created_at`}>
          {this.formatTime(row.created_at)}
        </td>
        <td key={`user-${row.id}-author`}>{`${row["post"]["views"]}`}</td>
        <td className="ml-auto" style={{ maxWidth: "50px" }}>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn-icon-only text-light"
              href="#pablo"
              role="button"
              size="sm"
              color=""
              onClick={(e) => e.preventDefault()}
            >
              <IconEllipsis className="size-5" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem
                tag={Link}
                to={"/dash/admin/videos/" + row.post.id + "/edit"}
              >
                編輯
              </DropdownItem>
              <DropdownItem
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.remove(row);
                }}
              >
                刪除
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));

    return (
      <OverlayLoading loading={this.props.loading}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col" key="multi-select">
                <button
                  type="button"
                  className="btn btn-default"
                  style={{ fontSize: 10 }}
                  onClick={this.props.toggleModal}
                >
                  批量操作
                </button>
              </th>
              {cols}
            </tr>
          </thead>
          <tbody>{data}</tbody>
        </Table>
      </OverlayLoading>
    );
  }
}

export default DataTable;
